var FileUploadProgress  = {
  methods: {
    startDisplayProgressBar(process) {
      this.progress = 0
      this.$nextTick(() => {
        this.fileUploadingInProgress = true;
        this.$modal.show('file-uploading')
        setTimeout(() => {
          this.progress = 10
          if(process) process();
        }, 100)
      })
    },
    startHideProrgressBar() {
      this.progress = 120;
      this.fileUploadingInProgress = false;
      setTimeout(() => {
        this.$modal.hide('file-uploading')
      }, 200);
    },
  },
  data() {
    return {
      progress: 0,
      fileUploadingInProgress: false,
    }
  }
}

export default FileUploadProgress;
